import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["children", "className", "closeable", "onClose", "titleText", "type", "use"];
import { ALERT_TYPES, ALERT_TYPE_INFO, ALERT_USE_DEFAULT } from '../alert/AlertTypes';
import H5 from '../elements/headings/H5';
import UICloseButton from '../button/UICloseButton';
import classNames from 'classnames';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export default function UIAlert(props) {
  const {
      children,
      className,
      closeable = false,
      onClose,
      titleText,
      type = ALERT_TYPE_INFO,
      use = ALERT_USE_DEFAULT
    } = props,
    rest = _objectWithoutPropertiesLoose(props, _excluded);
  const computedClassName = classNames("alert private-alert", ALERT_TYPES[type], className, closeable && 'private-alert--dismissable alert-dismissable', use === 'inline' && 'private-alert--inline');
  return /*#__PURE__*/_jsxs("div", Object.assign({}, rest, {
    "aria-atomic": true,
    "aria-live": "polite",
    className: computedClassName,
    role: "alert",
    children: [/*#__PURE__*/_jsxs("div", {
      className: "private-alert__inner",
      children: [titleText && /*#__PURE__*/_jsx(H5, {
        className: "private-alert__title",
        children: titleText
      }), /*#__PURE__*/_jsx("div", {
        className: "private-alert__body has--vertical-spacing",
        children: children
      })]
    }), closeable && /*#__PURE__*/_jsx(UICloseButton, {
      "aria-hidden": true,
      className: "close private-alert__close",
      onClick: onClose,
      size: "md"
    })]
  }));
}
UIAlert.displayName = 'UIAlert';